<template>
  <div class="login-module">
    <div class="login-tab">
      <div class="close-btn" @click="close">
        <span class="iconfont icon-a-CombinedShape4" style="font-size: 12px;"></span>
      </div>
      <p class="login-textc">设置密码</p>
      <p class="login-texte">SETTING PASSWORD</p>
      <el-form :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm">
        <div class="login-input">
          <div class="phoneinput">
            <div class="phone">
              <img src="../../assets/images/mima.png" alt />
            </div>
            <div class="c-input">
              <el-form-item type="primary" prop="password">
                <el-popover
                placement="right"
                popper-class="passtitleEr"
                title=""
                width="200"
                trigger="click"
                content="6-16位，且包含大写字母、小写字母、数字、下划线至少三种组合">
                 <el-input  slot="reference" maxlength="16" placeholder="请输入新密码" v-model="editForm.password" @input="isShowClick"
                  :type="passwordType"></el-input>
              </el-popover>
               

                <img v-show="isShoweye==true" v-if="passwordType!=''" class="look" src="../../assets/images/guangbi.png"
                  alt @click="showPassword" />

                <img v-show="isShoweye==true" v-else class="look" src="../../assets/images/chakan.png" alt
                  @click="showPassword" />
              </el-form-item>
              <div class="errorhint" v-show="errorhint">{{errorhinttext}}</div>
            </div>
          </div>

          <div class="phoneinput">
            <div class="phone">
              <img src="../../assets/images/mima.png" alt />
            </div>
            <div class="c-input">
              <el-form-item type="primary">
                <el-input maxlength="16" placeholder="请再次输入密码" v-model="editForm.againpasswordnumber"
                  :type="okpasswordType" @input="againisShowClick"></el-input>
                <img v-show="againisShoweye==true" v-if="okpasswordType!=''" class="look"
                  src="../../assets/images/guangbi.png" alt @click="okshowPassword" />

                <img v-show="againisShoweye==true" v-else class="look" src="../../assets/images/chakan.png" alt
                  @click="okshowPassword" />
              </el-form-item>
              <div class="errorhint" v-show="errorhinttwo">{{errorhinttexttwo}}</div>
            </div>
          </div>
          <div class="register">
            <el-button type="primary" :class="[nextdisabled==false?'el-button--primary':'el-button--primaryno']"
              :disabled="nextdisabled" @click.native.prevent="loginClick">完成</el-button>
          </div>
          <!-- <div class="right-bottom">
            <span @click="handleTab">账号登录 ></span>
          </div> -->
        </div>
      </el-form>
      <transition name="plus-icon">
        <HintPrompt :markedwords="markedwords" v-show="hintpromptstate" />
      </transition>
    </div>
    <!-- 背景 -->
    <!-- <div class="login-back">
      <div class="back-text">
        <h2>在线直播</h2>
        <p class="po">便携录播系统具有一键推送全网直播功能</p>
        <p class="pt">支持触摸操作，可显示多路预览画面以及主播画面，可控制摄像头转动与变焦</p>
        <div class="register-zc" @click="registerClick">登录</div>
      </div>
    </div> -->
  </div>
</template>

<script>
  import HintPrompt from "@/components/wx-hintprompt";
  import { forgetPassUpdate, login, userById } from "@/api/login";
  import { menuButtonByToken } from "@/api/power";
  import {
    setToken,
    setUuid,
    setroleId,
    setschoolId,
    setuserName,
    setuserPhone,
    setheadPath,
    setschoolCode,
  } from "@/utils/auth";
  export default {
    components: { HintPrompt },
    props: {
      loginparameters: {
        type: Object,
        default: () => { },
      },
    },
    data() {
      return {
        time: null,
        timea: null,
        // inconsistent: false,
        hintpromptstate: false, //提示框状态
        markedwords: "", //提示框文字
        errorhint: false,
        errorhinttext: "",
        errorhinttwo: false,
        errorhinttexttwo: "",
        nextdisabled: true, //下一步颜色
        isShoweye: false,
        againisShoweye: false,
        passwordType: "password",
        okpasswordType: "password",
        logindata: this.loginparameters,
        editForm: {
          password: "",
          againpasswordnumber: "",
        },
        editFormRules: {
          password: [
            {
              required: true,
              message: "新密码不能为空",
              trigger: "blur",
            },
            {
              required: true,
              pattern: "^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\\W_]+$)(?![a-z0-9]+$)(?![a-z\\W_]+$)(?![0-9\\W_]+$)[a-zA-Z0-9\\W_]{6,16}$",
              message: "密码设置不符合要求",
              trigger: "blur",
            },
          ],
        },
      };
    },

    computed: {},
    methods: {
      isShowClick() {
        this.isShoweye = false;
        this.errorhint = false;
        if (this.editForm.password == "") {
          this.isShoweye = false;
          this.passwordType = "password";
        } else {
          this.isShoweye = true;
        }

        if (
          this.editForm.password != "" &&
          this.editForm.againpasswordnumber != ""
        ) {
          this.nextdisabled = false;
        } else {
          this.nextdisabled = true;
        }
      },
      againisShowClick() {
        this.signdisabled = true;
        this.errorhint = false;
        this.errorhinttwo = false;
        if (this.editForm.againpasswordnumber !== "") {
          this.signdisabled = false;
        }
        this.againisShoweye = false;
        if (this.editForm.againpasswordnumber == "") {
          this.againisShoweye = false;
          this.okpasswordType = "password";
        } else {
          this.againisShoweye = true;
        }

        if (
          this.editForm.password != "" &&
          this.editForm.againpasswordnumber != ""
        ) {
          this.nextdisabled = false;
        } else {
          this.nextdisabled = true;
        }
      },

      showPassword() {
        this.passwordType === ""
          ? (this.passwordType = "password")
          : (this.passwordType = "");
      },

      okshowPassword() {
        this.okpasswordType === ""
          ? (this.okpasswordType = "password")
          : (this.okpasswordType = "");
      },
      loginClick() {
        // let passwordInt ="^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\\W_]+$)(?![a-z0-9]+$)(?![a-z\\W_]+$)(?![0-9\\W_]+$)[a-zA-Z0-9\\W_]{6,16}$"///^[0-9a-zA-Z_]{6,16}$/;
        // if (passwordInt.test(this.editForm.password) == false) {
        //   this.errorhint = true;
        //   this.errorhinttext = "6-16位，且包含大写字母、小写字母、数字、下划线至少三种组合";
        // } else 
        this.$refs.editForm.validate((valid, value) => {
          if (valid) {
            if (this.editForm.againpasswordnumber !== this.editForm.password) {
              this.errorhinttwo = true;
              this.errorhinttexttwo = "两次密码输入不一致";
            } else {
              this.errorhint = false;
              this.errorhinttwo = false;
              let settingObj = {
                password: this.editForm.password,
                code: this.logindata.settingCode,
                username: this.logindata.settingUsername,
              };
              forgetPassUpdate(settingObj).then((res) => {
                if (res.code === 200) {
                  this.$message({
                    message: '修改成功',
                    type: 'success',
                    center: true,
                  })
                  this.$emit('login')
                  let getlogin = {
                    password: this.editForm.password,
                    platformCode: window.g.platformCode, //教育
                    username: this.logindata.settingUsername,
                  };
                  this.time = setTimeout(() => {
                    this.hintpromptstate = false;
                  }, 1000);
                } else if (res.code === 3000) {
                  this.hintpromptstate = true;
                  this.markedwords = "设置密码超时,请重新设置";
                  this.timea = setTimeout(() => {
                    this.hintpromptstate = false;
                  }, 1000);
                }else if (res.code === 1005) { 
                  this.$message({
                      message: res.msg,
                      type: "warning",
                      center: true,
                  });
                } 
              });
            }
          }
        })
      },
      handleTab() {
        this.$emit('login')
      },
      close() {
        // this.$store.commit('loginState', false);
        this.logindata.logindata = true;
        this.logindata.forgetdata = false;
        this.logindata.settingdata = false;
      }
    },
    mounted() { },
    destroyed() { },
    created() { },
    updated() { },
    beforeDestroy(){
      clearTimeout(this.time)
      clearTimeout(this.timea)
    }
  };
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import './index.styl';
</style>


// WEBPACK FOOTER //
// src/components/wx-settingpassword/index.vue